import { Label } from '@library/forms';
import { CircularProgress } from '@library/loaders/components';
import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { IFloorPlanModel } from '@api/models';
import { deleteFloorPlan } from '@api/services/site-walk.service';
import { Button, Drawer } from '@hyperflake/react-ui-library';

interface DeleteFloorPlanDrawerProps {
    open: boolean;
    onClose: () => void;
    floorPan: IFloorPlanModel;
    onDelete: (floorPlan: IFloorPlanModel) => void;
}

const DeleteFloorPlanDrawer = (props: DeleteFloorPlanDrawerProps) => {
    const { open, onClose, floorPan, onDelete } = props;

    const { clientId, projectId } = useParams();

    const deleteFloorPlanMutation = useMutation(() => deleteFloorPlan(clientId, projectId, floorPan._id));

    const handleDelete = async () => {
        try {
            await deleteFloorPlanMutation.mutateAsync();

            onDelete(floorPan);

            toast.success('Floor Plan deleted Successfully.');

            onClose();
        } catch (ex: any) {
            onClose();
            console.log(ex.status);
            if (ex.status === 400) {
                toast.error(ex.data.message);
            } else {
                toast.error(ex?.data?.message || 'Some error occured, please try again.');
                console.log(ex);
            }
        }
    };

    return (
        <Drawer open={open} onClose={onClose} title="Confirm Delete">
            <div>
                <div>
                    <Label className="mt-8 inline-block">
                        Are you sure you want to delete <span className="text-grayscale-900">“{floorPan?.name}”</span>
                        floor Plan?
                    </Label>

                    <div className="flex gap-2 mt-2">
                        <Button onClick={onClose} variant="default" color={'primary'}>
                            Cancel
                        </Button>
                        <Button
                            disabled={deleteFloorPlanMutation.isLoading}
                            className="w-20"
                            onClick={handleDelete}
                            variant="default"
                            color={'danger'}
                        >
                            {deleteFloorPlanMutation.isLoading ? <CircularProgress size={18} /> : 'Delete'}
                        </Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default DeleteFloorPlanDrawer;
